import { useBasePage } from "../../hooks/useBasePage";
import type { LayoutState } from "./LayoutState";

const initialState: LayoutState = {
  isSidebarOpen: false,
};

export function Layout() {
  const { state, setStateProperty } = useBasePage<LayoutState>(initialState);

  const openSidebar = (): void => {
    setStateProperty("isSidebarOpen", true);
  };

  const closeSidebar = (): void => {
    setStateProperty("isSidebarOpen", false);
  };

  return {
    state,
    openSidebar,
    closeSidebar,
  };
}
